<template>
    <div>
        <flash-error ref="flashError"></flash-error>
        <progress-bar percentages="30"></progress-bar>
        <section id="service-section" class="py-2 mobile-container">
            <div class="d-flex align-items-center justify-content-between text-light">
                <div>Services</div>
                <div>
                    <div class="info-box d-flex align-items-center justify-content-center cursor-pointer"
                         @click="openModalIframe"
                    >
                        <span class="material-symbols-outlined" style="font-size: 20px;">info_i</span>
                    </div>
                </div>
            </div>
        </section>
        <section id="text-section" class="mobile-container bg-light">
            <div class="py-2">
                <div class="mb-2">
                    <div class="mb-1">Nuværende valg:</div>
                    <div v-if="currentServices.length > 0">
                        <div v-for="service in currentServices" :key="service.id">
                           <input type="checkbox" disabled checked>
                            <label class="ml-2 mb-0">
                                {{ service.name }}
                            </label>
                        </div>
                    </div>
                    <div v-else-if="booking.product">
                        <input type="checkbox" disabled checked>
                        <label class="ml-2 mb-0">
                            {{ booking.product.description }}
                        </label>
                    </div>
                </div>
                <br>
                <div class="mb-2">
                    <div class="mb-1">Se mulige tilvalg:</div>
                    <div v-if="countdownVisible" class="alert alert-warning py-2 px-3 mb-2">
                        Der er <strong>{{ timeLeft }}</strong> tilbage, før priserne stiger til +{{ upcomingPercentage }}%.
                    </div>
                    <div class="d-flex mb-1" v-if="additionalServices[additionalServiceCallFromDriver]">
                        <input type="checkbox"
                               :id="`additional-${additionalServiceCallFromDriver}`"
                               v-model="additionalServices[additionalServiceCallFromDriver].enabled"
                        >
                        <label class="ml-2 mb-0" :for="`additional-${additionalServiceCallFromDriver}`">
                            {{ additionalServices[additionalServiceCallFromDriver].name }}
                            ({{ displayPrice(callFromDriverBasePrice) }} kr.)
                        </label>
                    </div>
                    <div v-for="(item, key) in additionalServices"
                         v-if="[additionalServiceShorterTimeInterval].includes(key)"
                    >
                        <div class="d-flex mb-1">
                            <input type="checkbox"
                                   :id="`additional-${key}`"
                                   v-model="item.enabled"
                            >
                            <label class="ml-2 mb-0" :for="`additional-${key}`">
                                {{ item.name }}
                            </label>
                        </div>
                        <div v-if="key === additionalServiceShorterTimeInterval && item.enabled"
                             class="mb-2"
                        >
                            <div class="align-items-center bg-white rounded-lg div-focus">
                                <select v-model="additionalServices[key].value"
                                        class="form-control"
                                        @change="onChangeShorterTimeInterval">
                                    <option value=""></option>
                                    <option v-for="interval in shorterTimeIntervals"
                                            :value="interval"
                                    >
                                        {{ interval.from }} - {{ interval.to }} ({{ displayPrice(interval.basePrice) }} kr.)
                                    </option>
                                </select>
                            </div>
                            <div class="text-danger" v-if="errors[additionalServiceShorterTimeInterval]">
                                {{ errors[additionalServiceShorterTimeInterval] }}
                            </div>
                        </div>
                    </div>
                    <div v-if="availableServices.length" class="mt-3">
                        <div v-for="(service, i) in availableServices" class="d-flex">
                            <input type="checkbox"
                                   :value="service['id']"
                                   :id="`prime-${service['id']}`"
                                   v-model="availableServices[i].enabled"
                                   @change="onChangePrimeService(service)"
                            />
                            <label class="ml-2 mb-0" :for="`prime-${service['id']}`">
                                {{ service.name }} ({{ displayPrice(service.basePrice) }} kr.)
                            </label>
                        </div>
                    </div>
                    <div v-for="(addOn, index) in addOns">
                        <div class="d-flex mb-1">
                            <input type="checkbox"
                                   :id="`add-on-${index}`"
                                   v-model="addOn.enabled"
                            >
                            <label class="ml-2 mb-0" :for="`add-on-${index}`">
                                {{ addOn.add_on.name }} ({{ displayPrice(addOn.basePrice) }} kr.)
                            </label>
                        </div>
                    </div>
                </div>
                <br>
                <div>
                    <button class="btn btn-success" @click="goNext">Næste STEP</button>
                </div>
            </div>
        </section>
        <back-section :url="prevUrl" type="1"></back-section>

        <div
            ref="modal"
            class="modal fade"
            :class="{show, 'd-block': activeModalInterval}"
            tabindex="-1"
            role="dialog"
        >
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Info</h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                            @click="toggleModal"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div>
                            Din levering vil blive opgraderet til en STEP PRIME levering.
                            Da din levering nu vil kræve 2 knivskarpe chauffører, betyder det at din leveringsdag rykkes.
                            Du adviseres altid med leveringsdatoen 2 dage i forvejen, samt et 4-timers interval for leveringen dagen før.
                            Forbered dig bedst muligt på din levering via vores kundeguide.
                        </div>

                    </div>
                    <div class="modal-footer">
                        <button class="btn btn-primary mb-1" data-dismiss="modal" @click="toggleModal">
                            Ok
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="activeModalInterval || activeIframeModalInterval" class="modal-backdrop fade show"></div>

    </div>

</template>

<script>
import ProgressBar from "./reusable/ProgressBar.vue";
import BackSection from "./reusable/BackSection.vue";
import FlashError from "./reusable/FlashError.vue";
import priceMixin from "../../mixins/priceMixin";
import priceIntervalMixin from "../../mixins/priceIntervalMixin";
import dateTimeMixin from "../../mixins/dateTimeMixin";
import moment from "moment";
import customerSmsFlowMixin from "../../mixins/customerSmsFlowMixin";
export default {
    name: "CmfStep2",
    components: {FlashError, ProgressBar, BackSection},
    mixins: [priceMixin, priceIntervalMixin, dateTimeMixin, customerSmsFlowMixin],
    props: {
        booking: {type: Object, required: true},
        configurations: {type: Object, required: true},
        nextUrl: {type: String, required: true},
        prevUrl: {type: String, required: true},
        applyChangesUrl: {type: String, required: true},
        additionalServiceShorterTimeInterval: {type: String, required: true},
        additionalServicePrime: {type: String, required: true},
        additionalServiceCallFromDriver: {type: String, required: true},
        additionalServiceAddOns: {type: String, required: true},
        additionalServicesProp: {type: Object|Array, required: true},
        availableServicesProp: {type: Array, required: true},
        currentServicesProp: {type: Array, required: true},
        today: {type: String, required: true},
        tomorrow: {type: String, required: true},
        dayAfterTomorrow: {type: String, required: true},
        callFromDriverDropoffAddOn: {type: Object, required: false},
        addOnShorterTimeInterval: {type: Object, required: false},
        addOnsProp: {type: Array, required: false},
        shorterTimeIntervalPayedByClient: {type: Boolean, required: true},
        routeAvailableDays: {type: Object|Array, required: true},
        faqUrl: {type: String, required: true},
        tripTypeDropoff: {type: Number, required: true},
        serverNow: {type: String, required: true},
    },
    data() {
        return {
            activeIframeModalInterval: false,
            activeModalInterval: false,
            show: false,
            additionalServices: this.additionalServicesProp.length === undefined ? this.additionalServicesProp : {},
            availableServices: this.availableServicesProp,
            currentServices: this.currentServicesProp,
            shorterTimeIntervals: {},
            errors: {},
            isDeliveryDateValid: this.booking.dropoff_end &&
                !this.booking.dropoff_end.includes('-0001-11-30') &&
                !this.booking.dropoff_end.includes('0000-00-00'),
            addOns: JSON.parse(JSON.stringify(this.addOnsProp)),
            priceIntervals: this.configurations.sms_flow_price_intervals && this.configurations.sms_flow_price_intervals.value
                ? JSON.parse(this.configurations.sms_flow_price_intervals.value)
                : [],
            currentSeconds: this.timeToSeconds(this.serverNow),
            serverSecondsAtMount: this.timeToSeconds(this.serverNow),
            mountTimestamp: 0,
            priceTimer: null,
        }
    },
    mounted() {
        this.mountTimestamp = Date.now();
        this.priceTimer = setInterval(() => {
            let elapsed = Math.floor((Date.now() - this.mountTimestamp) / 1000);
            this.currentSeconds = (this.serverSecondsAtMount + elapsed) % 86400;
        }, 1000);
    },
    beforeDestroy() {
        if (this.priceTimer) {
            clearInterval(this.priceTimer);
        }
    },
    computed: {
        priceMultiplier() {
            return this.getPriceIncreaseMultiplier(this.priceIntervals, Math.floor(this.currentSeconds / 60));
        },
        currentPercentage() {
            return this.getActivePriceIncreasePercentage(this.priceIntervals, Math.floor(this.currentSeconds / 60));
        },
        nextPriceBoundary() {
            return this.getNextPriceBoundary(this.priceIntervals, Math.floor(this.currentSeconds / 60));
        },
        upcomingPercentage() {
            return this.nextPriceBoundary ? this.nextPriceBoundary.upcomingPercentage : 0;
        },
        countdownVisible() {
            // Only announce an upcoming increase (higher than the current rate).
            return this.nextPriceBoundary && this.upcomingPercentage > this.currentPercentage;
        },
        secondsUntilBoundary() {
            if (!this.nextPriceBoundary) {
                return 0;
            }
            let diff = this.nextPriceBoundary.boundaryMinutes * 60 - this.currentSeconds;
            if (diff <= 0) {
                diff += 86400;
            }
            return diff;
        },
        timeLeft() {
            return this.formatSecondsLeft(this.secondsUntilBoundary);
        },
        callFromDriverBasePrice() {
            return this.callFromDriverDropoffAddOn
                ? parseFloat(this.callFromDriverDropoffAddOn.configurations.price)
                : 0;
        },
    },
    created() {
        if (this.callFromDriverDropoffAddOn && !this.additionalServices[this.additionalServiceCallFromDriver]) {
            let callFromDriverSelectedByClient = false;
            // Don't show this option if 'call from driver' was selected on the booking page
            if (this.booking.agreement_add_ons.length) {
                this.booking.agreement_add_ons.forEach((agreementAddOn) => {
                    if (agreementAddOn.add_on_id === this.callFromDriverDropoffAddOn.add_on_id) {
                        callFromDriverSelectedByClient = true;
                    }
                });
            }
            if (!callFromDriverSelectedByClient) {
                this.$set(this.additionalServices, this.additionalServiceCallFromDriver, {
                    key: this.additionalServiceCallFromDriver,
                    name: this.callFromDriverDropoffAddOn.add_on.name,
                    value: this.callFromDriverDropoffAddOn.add_on.name,
                    basePrice: this.callFromDriverDropoffAddOn.configurations.price,
                    price: this.displayPrice(this.callFromDriverDropoffAddOn.configurations.price),
                    enabled: false
                });
            }
        }

        for (let x in this.addOns) {
            if (this.additionalServices[this.additionalServiceAddOns] &&
                this.additionalServices[this.additionalServiceAddOns][this.addOns[x].id]
            ) {
                this.$set(this.addOns[x], 'enabled', true);
            }
        }

        if (this.configurations.shorter_time_intervals) {
            let intervalMatchesRoute;

            if (this.addOnShorterTimeInterval) {
                this.shorterTimeIntervals = this.addOnShorterTimeInterval.configurations;
            } else {
                this.shorterTimeIntervals = JSON.parse(this.configurations.shorter_time_intervals.value);
            }

            let filteredTimeIntervals = [];
            for (let i in this.shorterTimeIntervals) {
                intervalMatchesRoute = true;
                if (Object.keys(this.routeAvailableDays).length) {
                    intervalMatchesRoute = false;
                    for (let r in this.routeAvailableDays) {
                        if (
                            (
                                this.routeAvailableDays[r]['from'] === '00:00' &&
                                this.routeAvailableDays[r]['to'] === '00:00'
                            ) ||
                            (
                                this.routeAvailableDays[r]['from'] <= this.shorterTimeIntervals[i]['from'] &&
                                this.routeAvailableDays[r]['to'] >= this.shorterTimeIntervals[i]['to']
                            )
                        ) {
                            intervalMatchesRoute = true;
                        }
                    }
                }

                if (!intervalMatchesRoute || this.shorterTimeIntervals[i]['option']) {
                    // Do nothing

                } else {
                    // Keep the raw base price; the time-of-day surcharge + VAT are applied
                    // live via displayPrice(). Payed-by-client intervals stay free.
                    let basePrice = this.shorterTimeIntervalPayedByClient ? 0 : this.shorterTimeIntervals[i].price;
                    this.$set(
                        this.shorterTimeIntervals[i],
                        'basePrice',
                        basePrice
                    );
                    filteredTimeIntervals.push(this.shorterTimeIntervals[i]);
                }
            }
            this.shorterTimeIntervals = filteredTimeIntervals;
        }

        for (let j in this.availableServices) {
            // Store the raw base price; surcharge + VAT applied live via displayPrice().
            this.$set(this.availableServices[j], 'basePrice', this.availableServices[j].price);
        }

        if (!this.additionalServices[this.additionalServiceShorterTimeInterval]) {
            this.$set(this.additionalServices, this.additionalServiceShorterTimeInterval, {
                key: this.additionalServiceShorterTimeInterval,
                name: 'Kortere tidsinterval',
                value: '',
                price: 0,
                enabled: false
            });
        }

        if(!this.additionalServices[this.additionalServicePrime] &&
            !this.booking['primeServicesWasSelected']
        ) {
            this.$set(this.additionalServices, this.additionalServicePrime, {key: this.additionalServicePrime});

        } else if(this.additionalServices[this.additionalServicePrime]) {
            for (let i in this.availableServices) {
                if (this.additionalServices[this.additionalServicePrime][this.availableServices[i]['id']] &&
                    this.additionalServices[this.additionalServicePrime][this.availableServices[i]['id']].enabled
                ) {
                    this.$set(this.availableServices[i], 'enabled', true);
                }
            }
        }
    },
    methods: {
        displayPrice(basePrice) {
            return this.calculatePriceWithVatAndRoundToNearestTens(basePrice * this.priceMultiplier);
        },
        // Snapshot the time-of-day adjusted prices (and base prices) into the
        // posted services so they reflect the multiplier active at submission.
        snapshotPrices() {
            let cfd = this.additionalServices[this.additionalServiceCallFromDriver];
            if (cfd) {
                this.$set(cfd, 'basePrice', this.callFromDriverBasePrice);
                this.$set(cfd, 'price', this.displayPrice(this.callFromDriverBasePrice));
            }

            let sti = this.additionalServices[this.additionalServiceShorterTimeInterval];
            if (sti && sti.value && sti.value.basePrice !== undefined) {
                this.$set(sti, 'basePrice', sti.value.basePrice);
                this.$set(sti, 'price', this.displayPrice(sti.value.basePrice));
            }

            let prime = this.additionalServices[this.additionalServicePrime];
            if (prime) {
                for (let i in this.availableServices) {
                    let s = this.availableServices[i];
                    if (prime[s.id] && prime[s.id].enabled) {
                        this.$set(prime[s.id], 'basePrice', s.basePrice);
                        this.$set(prime[s.id], 'price', this.displayPrice(s.basePrice));
                    }
                }
            }
        },
        validate() {
            this.errors = {};
            let arr = [this.additionalServiceShorterTimeInterval];

            for (let i = 0; i < arr.length; i++) {
                if (this.additionalServices[arr[i]] &&
                    this.additionalServices[arr[i]].enabled &&
                    !this.additionalServices[arr[i]].value
                ) {
                    this.$set(this.errors, arr[i], 'The value can\'t be empty');
                }
            }
        },
        goNext() {
            this.validate();
            this.snapshotPrices();
            this.additionalServices[this.additionalServiceAddOns] = {key: this.additionalServiceAddOns};
            for (let x in this.addOns) {
                if (this.addOns[x]['enabled']) {
                    this.$set(this.additionalServices[this.additionalServiceAddOns], this.addOns[x].id, {
                        addOnId: this.addOns[x].add_on.id,
                        name: this.addOns[x].add_on.name,
                        basePrice: this.addOns[x].basePrice,
                        price: this.displayPrice(this.addOns[x].basePrice)
                    });
                }
            }
            setTimeout(() => {
                if (!Object.keys(this.errors).length) {
                    axios.post(this.applyChangesUrl, this.additionalServices)
                        .then((response) => {
                            window.location.href = this.nextUrl;

                        }).catch(error => {
                        this.$refs.flashError.flashError(error);
                    });
                }
            }, 50);

        },
        toggleModal() {
            const body = document.querySelector("body");
            this.activeModalInterval = !this.activeModalInterval;
            this.activeModalInterval
                ? body.classList.add("modal-open")
                : body.classList.remove("modal-open");
            setTimeout(() => (this.show = !this.show), 10);
        },
        onChangeShorterTimeInterval() {
            setTimeout(() => {
                let sti = this.additionalServices[this.additionalServiceShorterTimeInterval];
                if (sti['value'] && sti['value']['basePrice'] !== undefined) {
                    this.$set(sti, 'basePrice', sti['value']['basePrice']);
                    this.$set(sti, 'price', this.displayPrice(sti['value']['basePrice']));
                } else {
                    this.$set(sti, 'basePrice', 0);
                    this.$set(sti, 'price', 0);
                }
            }, 500);
        },
        onChangePrimeService(service) {
            this.$set(this.additionalServices[this.additionalServicePrime], service['id'], {
                name: service.name,
                basePrice: service.basePrice,
                price: this.displayPrice(service.basePrice),
                enabled: service.enabled
            });

            if (this.isDeliveryDateValid && service.enabled) {
                this.toggleModal();
            }
        }
    },
}

</script>

<style scoped>

</style>
